export default function DesignPreview({ data, onClose }) {
  return (
    <div className="design-preview-overlay" onClick={onClose}>
      <div className="design-preview" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✕</button>

        <h2>Design Preview</h2>

        <div className="preview-content">
          {data.rendered_image_url ? (
            <div className="preview-image">
              <img src={data.rendered_image_url} alt="Design preview" />
            </div>
          ) : (
            <div className="preview-info">
              <p><strong>Status:</strong> {data.status}</p>
              {data.status === 'pending' && <p>Your design is being rendered...</p>}
              {data.status === 'completed' && <p>Design rendered successfully!</p>}
              {data.status === 'failed' && (
                <>
                  <p className="error">Design rendering failed</p>
                  {data.error_message && <p>{data.error_message}</p>}
                </>
              )}
            </div>
          )}

          <div className="preview-details">
            <div className="item-info">
              <h3>Item 1</h3>
              <p><strong>Name:</strong> {data.item1_name}</p>
              <p><strong>Quantity:</strong> {data.item1_quantity}</p>
              <p><strong>Price:</strong> Rs. {data.item1_price}</p>
            </div>

            {data.item2_name && (
              <div className="item-info">
                <h3>Item 2</h3>
                <p><strong>Name:</strong> {data.item2_name}</p>
                <p><strong>Quantity:</strong> {data.item2_quantity}</p>
                <p><strong>Price:</strong> Rs. {data.item2_price}</p>
              </div>
            )}
          </div>
        </div>

        <button className="close-btn-bottom" onClick={onClose}>Close</button>
      </div>
    </div>
  )
}
